export const apiTimeframeOptions = {
  oneDay: 'one_day',
  twoDays: 'two_days',
  oneWeek: 'one_week',
  oneMonth: 'one_month',
}